/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse } from 'axios';
import { processRequestError } from '../error/actions';
import {
  GET_CARTS_REQUEST,
  GET_CART_REQUEST,
  CREATE_CART_REQUEST,
  DELETE_CART_REQUEST,
  COMMIT_CART_REQUEST,
  ADD_ITEMS_REQUEST,
  GET_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_REQUEST,
  DELETE_CART_ITEM_REQUEST,
  SEARCH_SUPPLIERS_REQUEST,
  SupplierDTO,
  GET_SUPPLIERS_REQUEST,
  SearchResultsProps,
} from './types';
import {
  getCartsAction,
  getCartByIdAction,
  createCartAction,
  deleteCartAction,
  commitCartAction,
  addItemsAction,
  getCartItemAction,
  updateCartItemAction,
  deleteCartItemAction,
  searchSuppliersAction,
  getSuppliersAction,
} from './actions';
import { CartsApi } from '../../services/Cart';
import { showToastSaga } from '../../utils/useToastSaga';
import { searchByVINAction } from '../catalog/actions';

// Сага для получения списка корзин
function* handleGetCartsSaga(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(CartsApi.getCarts);
    yield put(getCartsAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getCartsAction.failure }));
  }
}

// Сага для получения одной корзины по ID
function* handleGetCartSaga(action: ReturnType<typeof getCartByIdAction.request>): SagaIterator {
  try {
    const response: AxiosResponse = yield call(CartsApi.getCart, action.payload);
    yield put(getCartByIdAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getCartByIdAction.failure }));
  }
}

// Сага для создания корзины
function* handleCreateCartSaga(action: ReturnType<typeof createCartAction.request>): SagaIterator {
  try {
    const response: AxiosResponse = yield call(CartsApi.createCart, action.payload);
    yield put(createCartAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: createCartAction.failure }));
  }
}

// Сага для удаления корзины
function* handleDeleteCartSaga(action: ReturnType<typeof deleteCartAction.request>): SagaIterator {
  try {
    yield call(CartsApi.deleteCart, action.payload);
    yield put(deleteCartAction.success(action.payload));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: deleteCartAction.failure }));
  }
}

// Сага для коммита корзины
function* handleCommitCartSaga(action: ReturnType<typeof commitCartAction.request>): SagaIterator {
  try {
    const response: AxiosResponse = yield call(CartsApi.commitCart, action.payload);
    yield put(commitCartAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: commitCartAction.failure }));
  }
}

// Сага для добавления товаров в корзину
function* handleAddItemsSaga(action: ReturnType<typeof addItemsAction.request>): SagaIterator {
  try {
    const { items } = action.payload;
    const response: AxiosResponse = yield call(() => CartsApi.addItems(items));
    yield put(addItemsAction.success(response.data));
    showToastSaga('Товар успешно добавлен в корзину!', 'success');
    yield put(getCartsAction.request);
  } catch (error: AxiosResponse['data']) {
    showToastSaga('Упс, что-то пошло не так', 'error');
    yield put(processRequestError({ error, failAction: addItemsAction.failure }));
  }
}

// Сага для получения товара по ID из корзины
function* handleGetCartItemSaga(
  action: ReturnType<typeof getCartItemAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(CartsApi.getCartItem, action.payload);
    yield put(getCartItemAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getCartItemAction.failure }));
  }
}

// Сага для обновления товара в корзине
function* handleUpdateCartItemSaga(
  action: ReturnType<typeof updateCartItemAction.request>,
): SagaIterator {
  try {
    const { id, item } = action.payload;
    const response: AxiosResponse = yield call(CartsApi.updateCartItem, id, item);
    yield put(updateCartItemAction.success(response.data));
    yield put(getCartsAction.request());
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: updateCartItemAction.failure }));
  }
}

// Сага для удаления товара из корзины
function* handleDeleteCartItemSaga(
  action: ReturnType<typeof deleteCartItemAction.request>,
): SagaIterator {
  try {
    yield call(CartsApi.deleteCartItem, action.payload);
    yield put(deleteCartItemAction.success());
    yield put(getCartsAction.request());
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: deleteCartItemAction.failure }));
  }
}

function* handleSearchSuppliersSaga(
  action: ReturnType<typeof searchSuppliersAction.request>,
): SagaIterator {
  try {
    const params = {
      ...action.payload,
      supplier: action.payload.supplier,
    };
    console.log(params, ' paraparamsms');

    const response: AxiosResponse<SearchResultsProps> | any = yield call(
      CartsApi.searchSuppliers,
      params,
    );
    console.log(response, 'response');

    // yield put(searchByVINAction.success(response.data.acat_search));

    yield put(searchSuppliersAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: searchSuppliersAction.failure }));
  }
}

// Сага для запроса списка поставщиков
function* handleGetSuppliersSaga(): Generator {
  try {
    const response: any = yield call(CartsApi.getSuppliers);
    yield put(getSuppliersAction.success(response));
  } catch (error: any) {
    yield put(getSuppliersAction.failure(error.message));
  }
}

// Главная сага для отслеживания всех действий
function* cartsSaga(): SagaIterator {
  yield takeLatest(GET_CARTS_REQUEST, handleGetCartsSaga);
  yield takeLatest(GET_CART_REQUEST, handleGetCartSaga);
  yield takeLatest(CREATE_CART_REQUEST, handleCreateCartSaga);
  yield takeLatest(DELETE_CART_REQUEST, handleDeleteCartSaga);
  yield takeLatest(COMMIT_CART_REQUEST, handleCommitCartSaga);
  yield takeLatest(ADD_ITEMS_REQUEST, handleAddItemsSaga);
  yield takeLatest(GET_CART_ITEM_REQUEST, handleGetCartItemSaga);
  yield takeLatest(UPDATE_CART_ITEM_REQUEST, handleUpdateCartItemSaga);
  yield takeLatest(DELETE_CART_ITEM_REQUEST, handleDeleteCartItemSaga);
  yield takeLatest(SEARCH_SUPPLIERS_REQUEST, handleSearchSuppliersSaga);
  yield takeLatest(GET_SUPPLIERS_REQUEST, handleGetSuppliersSaga);
}

export default cartsSaga;
